import { faker } from '@faker-js/faker'; // eslint-disable-line import/no-extraneous-dependencies
import { atom, useAtomValue, useSetAtom } from 'jotai';
import { atomWithReset } from 'jotai/utils';

export type AgentConfig = 'accounts_advisor' | 'platform_testing';

type SessionState = { agentConfig: AgentConfig; sessionId: string };

const sessionStateAtom = atomWithReset<SessionState>({
  agentConfig: 'accounts_advisor',
  sessionId: faker.datatype.uuid(),
});

const setAgentConfigAtom = atom(null, (_, set, newConfig: AgentConfig) => {
  set(sessionStateAtom, {
    agentConfig: newConfig,
    sessionId: faker.datatype.uuid(),
  });
});

export const useSessionState = () => {
  const sessionState = useAtomValue(sessionStateAtom);
  const setAgentConfig = useSetAtom(setAgentConfigAtom);

  return {
    sessionState,
    setAgentConfig,
  };
};
